import { createGlobalStyle } from "styled-components";

import "../styles/transition.css";

export default createGlobalStyle`

    g, path {
        &:focus{
        outline: none !important;
        }
    }

    @media (max-width:767px) {
        .recharts-legend-wrapper {
        position: initial;
        }

        .top-completed-scenarios-chart {
        .recharts-layer.recharts-cartesian-axis-tick text[type="category"]{
            transform: translateY(-15px) translateX(-8px);
        }
        }
        
        .area-chart {
        .recharts-layer.recharts-cartesian-axis.recharts-xAxis.xAxis .recharts-cartesian-axis-ticks g:first-of-type {
            transform: translateX(15px);
        }

        .recharts-layer.recharts-cartesian-axis.recharts-xAxis.xAxis .recharts-cartesian-axis-ticks g:last-of-type {
            transform: translateX(-15px);
        }
        }
    }

    .recharts-tooltip-wrapper {
        outline: none;
    }

    .recharts-pie .recharts-sector {
    transition: all 0.1s ease-out;
    cursor: pointer;
}

    .custom-chart .recharts-yAxis .recharts-cartesian-axis-tick-line {
        transform: translateX(-15px);
    }

    .custom-chart .recharts-yAxis .recharts-label {
        text-anchor: middle;
    }

    .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track,
    .MuiSwitch-switchBase:not(.Mui-checked) + .MuiSwitch-track {
        border-radius: 1.875rem;
    }
`;
